<template>
  <div class="forget-password">
    <!-- <van-sticky>
      <van-nav-bar safe-area-inset-top title="修改密码" left-arrow @click-left="onClickLeft" />
    </van-sticky> -->
    <div class="password-box">
      <van-form @submit="onSubmit">
        <van-field
          v-model="state.viewPhone"
          name="phone"
          placeholder="请输入绑定的手机号"
          :rules="[{ required: true, message: '请输入手机号' }]"
          :border="false"
        >
          <template #left-icon>
            <img src="../../../assets/personal/ic_phone_65px.png" />
          </template>
        </van-field>
        <van-field
          v-model="state.sms"
          center
          clearable1
          name="sms"
          placeholder="请输入短信验证码"
          :rules="[{ required: true, message: '请填验证码' }]"
          :border="false"
        >
          <template #left-icon>
            <img src="../../../assets/personal/ic_message.png" />
          </template>
          <template #button>
            <van-button
              v-show="state.Verification"
              size="small"
              round
              type="primary"
              color="#12CEC7"
              @click="handleClick"
              class="getVerfiy"
              :border="false"
              >发送</van-button
            >
            <van-button
              v-show="!state.Verification"
              size="small"
              round
              type="primary"
              color="#12CEC7"
              class="getVerfiy"
              >{{ state.timer }}s</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="state.password"
          type="password"
          name="password"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
          :border="false"
        >
          <template #left-icon>
            <img src="../../../assets/personal/ic_password_65px.png" />
          </template>
        </van-field>
        <van-field
          v-model="state.confirmpassword"
          type="password"
          name="confirmpassword"
          placeholder="请在次输入新密码"
          :rules="[{ required: true, message: '请输入确认密码' }]"
          :border="false"
          :error-message="
            state.password === state.confirmpassword ? '' : '两次输入密码不一致'
          "
        >
          <template #left-icon>
            <img src="../../../assets/personal/ic_password_65px.png" />
          </template>
        </van-field>
        <van-button
          round
          block
          type="primary"
          color="#12CEC7"
          native-type="submit"
          class="submit"
          :disabled="state.password !== state.confirmpassword"
          >确定</van-button
        >
      </van-form>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import { yzm, forgetPassword } from "@/api/user";
import { getverfiy } from "@/api/yzlogin";
export default {
  name: "password",
  setup(props) {
    const router = useRouter();
    const state = reactive({
      Verification: true, //通过v-show控制显示获取还是倒计时
      timer: 60, //定义初始时间为60s,
      sms: "",
      password: "",
      confirmpassword: "",
      phone: "",
      viewPhone: "",
    });
    // 返回
    const onClickLeft = () => {
      router.back();
    };

    //页面挂载完成
    onMounted(() => {
      let phoneNum = router.currentRoute.value.query.phoneNum;
      // state.viewPhone = phoneNum.substring(0,3) + '****' + phoneNum.slice(-3)
      state.phone = state.viewPhone;
      console.log(state.phone);
    });

    // 发送短信倒计时
    let fetchFlag = false;
    const handleClick = () => {
      if (state.viewPhone) {
        if (fetchFlag) return;
        fetchFlag = true;
        yzm({ val: state.viewPhone, type: 5 }).then((response) => {
          fetchFlag = false;
          console.log(response);
          if (response.data.code == 1) {
            Toast(response.data.msg);
            state.Verification = false; //点击button改变v-show的状态
            let auth_timer = setInterval(() => {
              //定时器设置每秒递减
              state.timer--; //递减时间
              if (state.timer <= 0) {
                state.Verification = true; //60s时间结束还原v-show状态并清除定时器
                clearInterval(auth_timer);
                state.timer = 60;
              }
            }, 1000);
          } else {
            // Toast(response.data.smg)
          }
        });
      } else {
        Toast("请输入手机号");
      }
    };

    const onSubmit = (values) => {
      forgetPassword({
        phone: state.viewPhone,
        yzm: values.sms,
        password: values.password,
        repassword: values.confirmpassword,
      }).then((response) => {
        console.log(response);
        if (response.data.code == 1) {
          Toast("修改成功");
          window.document.location = "goBack://";
          // router.back()
        } else {
          Toast(response.data.msg);
        }
      });
      // Toast('修改成功')
    };

    return {
      state,
      onClickLeft,
      handleClick,
      onSubmit,
    };
  },
};
</script>

<style scoped="scoped">
.forget-password {
  background-color: #f7f8fa;
  height: 100vh;
}
.password-box {
  padding: 30px;
}

/* .van-button--round{
  margin-top: 100px;
} */
.van-form {
  height: 100%;
  background-color: #f7f8fa;
}
.getVerfiy {
  width: 156px;
  height: 60px;
  color: #12cec7;
}
.submit {
  margin-top: 100px;
}

.van-cell {
  background: #fff;
}
.van-field {
  margin-bottom: 30px;
  border-radius: 10px;
}

.van-field__left-icon img {
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
:deep(.van-field__control) {
  color: #333;
}
</style>
